import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import './stock-difference.css';

const StockDifference = () => {
  const families = useSelector(state => state.IngredientReducer.families || []);
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    familyId: '',
    ingredientId: ''
  });
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const totals = history.reduce((acc, entry) => ({
    totalDifference: acc.totalDifference + entry.difference,
    totalPrice: acc.totalPrice + entry.price
  }), { totalDifference: 0, totalPrice: 0 });

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const params = {
        startDate: filters.startDate ? new Date(filters.startDate).toISOString().split('T')[0] : undefined,
        endDate: filters.endDate ? new Date(new Date(filters.endDate).setDate(new Date(filters.endDate).getDate() + 1)).toISOString().split('T')[0] : undefined,
        familyId: filters.familyId || undefined,
        ingredientId: filters.ingredientId || undefined
      };
      const response = await axios.get('/api/Stock/history', { params });
      setHistory(response.data);
    } catch (error) {
      console.error('Erreur:', error.response?.data || error.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchHistory();
  }, [filters.startDate, filters.endDate, filters.familyId, filters.ingredientId]);

  const handleFilterChange = (name, value) => {
    setFilters(prev => ({ ...prev, [name]: value, ...(name === 'familyId' && { ingredientId: '' }) }));
  };

  const filteredHistory = history.filter(item => filters.ingredientId ? item.ingredientId === filters.ingredientId : true);
  const filteredTotals = filteredHistory.reduce((acc, entry) => ({
    totalDifference: acc.totalDifference + entry.difference,
    totalPrice: acc.totalPrice + entry.price
  }), { totalDifference: 0, totalPrice: 0 });

  return (
    <div className="stock-difference-container">
      <h2>Historique des Modifications</h2>

      {/* Filtres */}
      <div className="filters">
        <div className="filter-group">
          <label>Date début</label>
          <input
            type="date"
            value={filters.startDate}
            onChange={(e) => handleFilterChange('startDate', e.target.value)}
          />
        </div>

        <div className="filter-group">
          <label>Date fin</label>
          <input
            type="date"
            value={filters.endDate}
            onChange={(e) => handleFilterChange('endDate', e.target.value)}
          />
        </div>

        <div className="filter-group">
          <label>Famille</label>
          <select
            value={filters.familyId}
            onChange={(e) => handleFilterChange('familyId', e.target.value)}
          >
            <option value="">Toutes</option>
            {families.map(family => (
              <option key={family._id} value={family._id}>
                {family.name}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Ingrédient</label>
          <select
            value={filters.ingredientId}
            onChange={(e) => handleFilterChange('ingredientId', e.target.value)}
            disabled={!filters.familyId}
          >
            <option value="">Tous</option>
            {families.find(f => f._id === filters.familyId)?.ingredients.map(ing => (
              <option key={ing._id} value={ing._id}>
                {ing.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Tableau */}
      {loading ? (
        <div className="loading">Chargement en cours...</div>
      ) : (
        <div className="results">
          {filteredHistory.length > 0 ? (
            <>
              <table>
                <thead>
                  <tr>
                    <th>Ingrédient</th>
                    <th>Différence</th>
                    <th>Prix (DT)</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredHistory.map((entry, index) => (
                    <tr key={index}>
                      <td>{entry.ingredientName}</td>
                      <td className={`difference ${entry.difference < 0 ? 'negative' : 'positive'}`}>
                        {entry.difference.toFixed(3)}
                      </td>
                      <td>{entry.price?.toFixed(3) || '-'}</td>
                      <td>{new Date(entry.date).toLocaleDateString('fr-FR')}</td>
                    </tr>
                  ))}
                </tbody>
               <tfoot>
                      <tr className="total-row">
                        <td>Total</td>
                        <td>{filteredTotals.totalDifference.toFixed(3)}</td>
                        <td>{filteredTotals.totalPrice.toFixed(3)}</td>
                        <td></td>
                      </tr>
                    </tfoot>
              </table>
            </>
          ) : (
            <div className="no-results">Aucune modification trouvée</div>
          )}
        </div>
      )}
    </div>
  );
};

export default StockDifference;
